import React from 'react';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { required } from 'redux-form-validators';

import {
    FormInputContainerComponent,
    ItemComponent,
    InputComponent
} from './InputWrappersComponent';

/**
 * Wrap the InputComponent in a html structure
 * This component is passed to a Redux Form Field
 * @param {Component} InputComponent  input component
 * @param {object} input see Redux form Props doc
 * @param {object} meta see Redux form Props doc
 */
export class FieldComponent extends React.Component {
    renderErrorMessage(meta) {
        return meta.touched && meta.error && <p className="color-err small">{meta.error}</p>;
    }

    render() {
        const {
            input,
            meta,
            label,
            placeholder,
            labelInfo,
            hideErrorMessage,
            classNameInputContainer,
            showSymbol
        } = this.props;
        return (
            <FormInputContainerComponent
                className={classNameInputContainer ? classNameInputContainer : ''}>
                <label htmlFor={input.name} className={`label ${labelInfo ? 'justify' : ''}`}>
                    <span>{label}</span>
                    {labelInfo ? <span className="labelInfo">{labelInfo}</span> : ''}
                </label>
                <ItemComponent className="item">
                    <InputComponent
                        {...this.props}
                        ref="inputRef"
                        placeholder={placeholder ? placeholder : label}
                    />
                    {showSymbol && <span>{showSymbol}</span>}
                </ItemComponent>
                {!hideErrorMessage && this.renderErrorMessage(meta)}
            </FormInputContainerComponent>
        );
    }
}

class InputFieldComponent extends React.Component {
    validateDefault = () => {
        if (this.props.isRequired) {
            return [
                required({
                    msg: this.props.i18nFeatureForm.REQUIRED,
                    allowBlank: !this.props.isRequired
                })
            ];
        }
        return [];
    };

    render() {
        const { isRequired, validate = [], label, placeholder } = this.props;
        return (
            <Field
                {...this.props}
                label={`${label ? label : ''}${label && isRequired ? '*' : ''}`}
                placeholder={`${placeholder ? placeholder : ''}${
                    placeholder && isRequired ? '*' : ''
                }`}
                validate={[...this.validateDefault(), ...validate]}
                component={FieldComponent}
            />
        );
    }
}
/**
 * className :  additionnal css class to input element (node .input)
 */
InputFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['email', 'text', 'date', 'password', 'number', 'tel']).isRequired,
    label: PropTypes.string,
    labelInfo: PropTypes.object,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    validate: PropTypes.array,
    warn: PropTypes.func,
    isRequired: PropTypes.bool,
    hideErrorMessage: PropTypes.bool,
    classNameInputContainer: PropTypes.string,
    i18nFeatureForm: PropTypes.object.isRequired,
    showSymbol: PropTypes.string
};

export default InputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/InputFieldComponent.js